
import { mdiInformation } from '@mdi/js'

const HOLIDAY_FROM = '2026-08-07'
const HOLIDAY_TO = '2026-08-28'

export default {
  name: 'HolidayBanner',
  data () {
    return {
      icons: {
        mdiInformation
      }
    }
  },
  computed: {
    displayedToDate () {
      return this.toDate.format('D MMMM')
    },
    fromDate () {
      return this.$dayjs(HOLIDAY_FROM)
    },
    toDate () {
      return this.$dayjs(HOLIDAY_TO)
    },
    visible () {
      return !!this.$user && this.visibleOnDate && this.visibleOnPage
    },
    visibleOnDate () {
      const now = new Date()

      return now >= this.fromDate && now < this.toDate.add(1, 'day')
    },
    visibleOnPage () {
      return [
        'collectivites-code_collectivite',
        'ddt-departement-collectivites',
        'ddt-departement-pac'
      ].includes(this.$route.name)
    }
  }
}
